import type { CSSProperties } from 'react';
import React from 'react';

import type { ProductType } from 'redux-store/slices/products/types';

type Props = Pick<ProductType, 'currency'> & {
  className?: string;
  price: string | number;
  style?: CSSProperties | undefined;
  Container?: keyof JSX.IntrinsicElements | React.ComponentType;
};

export default function FormattedPrice({
  price,
  currency = 'usd',
  className,
  style,
  Container = 'span',
}: Props): JSX.Element {
  let formattedPrice = `${price} ${currency}`;
  
  if (currency === 'usd') {
    formattedPrice = `$${price}`;
  }
  else if (currency === 'rub') {
    formattedPrice = `${price} ₽`;
  }
  else {
    const numericPrice: number = Number(price ?? 0);

    formattedPrice = new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: currency.toUpperCase(),
      currencyDisplay: 'symbol',
      minimumFractionDigits: 0,
      maximumFractionDigits: 2,
    }).format(numericPrice);
  }

  return (
    <Container className={className} style={style} translate="no">
      {formattedPrice}
    </Container>
  );
}
